import {
  FETCH_PERSON_SUCCESS,
  FETCH_PERSONS_MIN_SUCCESS,
  UPDATE_PERSON,
  ADD_PERSON,
  SET_PERSON_ID,
  UPLOAD_PERSON_PICTURE,
  CREATE_PERSON_START,
  UPDATE_PERSON_START_END,
  DELETE_PERSON_START,
  DELETE_PERSON_END,
} from "./types";

import {
  person,
  personsMinimal,
  personsUpdate,
  personsAdd,
  personSetRoll,
  personPictureUpload,
  personCreateStart,
  personUpdateStartEnd,
  personRemoveStart,
  personRemoveEnd,
} from "../api";
import { dataFailure, dataSuccess } from "./general";

const fetchPersonSuccess = (values) => {
  return {
    type: FETCH_PERSON_SUCCESS,
    payload: values,
  };
};

const fetchPersonsMinSuccess = (Persons) => {
  return {
    type: FETCH_PERSONS_MIN_SUCCESS,
    payload: Persons,
  };
};

export const fetchPerson = (values) => {
  return async (dispatch) => {
    try {
      const personsJSONData = await dispatch(person(values));
      await dispatch(fetchPersonSuccess(personsJSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const fetchPersonsMinimal = (values) => {
  return async (dispatch) => {
    try {
      const personsJSONData = await dispatch(personsMinimal(values));
      await dispatch(fetchPersonsMinSuccess(personsJSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updatePersonData = (values) => {
  return {
    type: UPDATE_PERSON,
    payload: values,
  };
};

export const updatePerson = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(personsUpdate(values));
      await dispatch(updatePersonData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const addPersonData = (values) => {
  return {
    type: ADD_PERSON,
    payload: values,
  };
};

export const addPerson = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(personsAdd(values));
      await dispatch(addPersonData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const createPersonStartData = (values) => {
  return {
    type: CREATE_PERSON_START,
    payload: values,
  };
};

export const createPersonStart = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(personCreateStart(values));
      await dispatch(createPersonStartData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updatePersonStartEndData = (values) => {
  return {
    type: UPDATE_PERSON_START_END,
    payload: values,
  };
};

export const updatePersonStartEnd = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(personUpdateStartEnd(values));
      await dispatch(updatePersonStartEndData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const deletePersonStartDate = (values) => {
  return {
    type: DELETE_PERSON_START,
    payload: values
  }
}

export const deletePersonStart = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(personRemoveStart(values));
      await dispatch(deletePersonStartDate(JSONData));      
    } catch (err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const deletePersonEndDate = (values) => {
  return {
    type: DELETE_PERSON_END,
    payload: values
  }
}

export const deletePersonEnd = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(personRemoveEnd(values));
      await dispatch(deletePersonEndDate(JSONData));      
    } catch (err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

export const setPersonId = (id) => {
  return {
    type: SET_PERSON_ID,
    payload: id,
  };
};

const uploadLogoData = (values) => {
  return {
    type: UPLOAD_PERSON_PICTURE,
    payload: values,
  };
};

export const uploadPicture = (values) => {
  return async (dispatch) => {
    try {
      const fileName = await dispatch(personPictureUpload(values));
      await dispatch(uploadLogoData(fileName));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const setRoll = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(personSetRoll(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};
